module.exports = __webpack_public_path__ + "img/engine-icon.a34c6063.png";